import { Helmet } from "react-helmet";
import HomeHeaderSection from "./components/HomeHeaderSection";
import HomeAnswerStripSection from "./components/HomeAnswerStripSection";
import HomeLogoMarqueeSection from "./components/HomeLogoMarqueeSection";
import HomeProgramsCarouselSection from "./components/HomeProgramsCarouselSection";
import HomeFinderSection from "./components/HomeFinderSection";
import HomeLearningModelSection from "./components/HomeLearningModelSection";
import HomeJourneySection from "./components/HomeJourneySection";
import HomeEvidenceSection from "./components/HomeEvidenceSection";
import HomeTrustStatsSection from "./components/HomeTrustStatsSection";
import HomePlatformSection from "./components/HomePlatformSection";
// import HomeCompaniesSection from "./components/HomeCompaniesSection";
import HomeBusinessSection from "./components/HomeBusinessSection";
import HomeTalentNetworkSection from "./components/HomeTalentNetworkSection";
import HomeWorkforceSection from "./components/HomeWorkforceSection";
import HomeStorySection from "./components/HomeStorySection";
import HomeFinalCtaSection from "./components/HomeFinalCtaSection";
import FloatingHomeRequestButton from "./components/FloatingHomeRequestButton";
import TestimonialsSection from "./components/TestimonialsSection";
import HomeTestimonialVideosSection from "./components/HomeTestimonialVideosSection";
import SiteFooter from "../../components/layout/SiteFooter";

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>
          Utiva | Learn Global Skills, Hire Top Talent, and Pay Talents Globally
        </title>
        <meta
          name="description"
          content="Utiva integrates learning, hiring, and compliant global payroll in one AI-powered OS - 19 countries, 200K talents"
        />
        <meta
          property="og:title"
          content="Utiva | Learn Global Skills, Hire Top Talent, and Pay Talents Globally"
        />
        <meta
          property="og:description"
          content="Utiva integrates learning, hiring, and compliant global payroll in one AI-powered OS - 19 countries, 200K talents"
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta
          name="keywords"
          content="Utiva courses, data analytics course Utiva, product management course online, UI/UX design course Nigeria, data science bootcamp online, business analysis course, cloud computing training, cybersecurity course online, AI and machine learning course, software engineering bootcamp, product design course, Python programming course, digital marketing course online, tech skills training Nigeria, online tech bootcamp Africa, data analytics certification for beginners Nigeria, 
          product management course with certificate Africa, UI/UX design bootcamp for beginners, 
          learn data science online from scratch, business analysis training with job placement, 
          AWS cloud computing course Nigeria, ethical hacking course for beginners Africa, 
          machine learning course for non-programmers, full stack web development bootcamp Nigeria, 
          Figma UI/UX course online Africa, SQL course for data analysts Nigeria, power BI course online Africa, 
          tableau training for beginners, agile product management course online, data engineering bootcamp Nigeria, 
          Excel for data analysis course Africa, Google data analytics certificate alternative Africa, 
          online certificate in cybersecurity Nigeria, no-code product management course, how to become a data analyst in Nigeria, 
          tech career switch course online Africa, remote tech job training program Nigeria, 6-week data analytics course online, 
          self-paced product design course Africa, affordable AI course Nigeria, best data analytics course in Nigeria, 
          best product management course online Africa, affordable tech bootcamp Nigeria, best UI/UX design school online, 
          top-rated data science course, cheapest coding bootcamp Africa, Utiva vs Coursera, 
          Utiva vs ALX, best online tech school in Nigeria, most affordable product design course, 
          best tech training platform for Africans, top cybersecurity course Nigeria, best business analysis course online, 
          Utiva vs Side Hustle Nigeria, Utiva vs Semicolon Africa, Utiva vs Google certificate, 
          best data analytics bootcamp vs self-study, is Utiva worth it, Utiva review Nigeria, best value tech training Africa 2025, 
          most affordable data science course with certificate Nigeria, which is better Utiva or Coursera for Africans, 
          top product management courses compared Africa, best free vs paid tech course Nigeria, highest rated UI/UX bootcamp Africa, 
          best online tech school for working adults Nigeria, data analytics course that guarantees a job Nigeria, affordable cybersecurity training Nigeria 2025, 
          best AI course for beginners in Africa, which tech skill pays the most in Nigeria 2025, best cloud certification course for Nigerians, 
          top rated data engineering courses Africa, most popular tech bootcamps Nigeria ranked, learn data analytics fast, quick tech skills training, get a tech job fast, 
          career change to tech, learn UI/UX in 3 months, become a data analyst quickly, job-ready tech course, fast-track product management training, 
          how to break into tech fast, urgent tech skill certification, get hired in tech fast, I lost my job and want to learn tech skills, 
          fastest way to become a data analyst in Nigeria, learn product management in 6 weeks, quick data science certification online, 
          how to get a remote tech job in 90 days, career pivot to tech in 2025, fastest tech course with job guarantee Nigeria, 
          I want to switch to tech urgently, become a UI/UX designer in 3 months Nigeria, accelerated business analyst training online, 
          how to learn Python fast for data science, short tech course with certificate Africa, online tech course I can finish in a month, 
          fastest way to earn a data analytics certificate, part-time tech bootcamp for working professionals, learn cloud computing in 8 weeks, 
          weekend data analytics class Nigeria, evening tech course for full-time workers Africa, how to become job-ready in tech fast, immediate enrollment tech bootcamp Nigeria, 
          data analytics course near me, tech training near me, UI/UX design class near me, product management training near me, coding bootcamp near me, online tech school Nigeria, data science class Lagos, 
          tech course Abuja, product design school near me, business analysis training near me, data analytics class Port Harcourt, tech bootcamp Ibadan, UI/UX course Enugu, online product management training Lagos, virtual tech school Nigeria, 
          tech scholarship Nigeria 2026, how to pivot into tech Nigeria, tech career change no coding experience, Utiva scholarship, how to break into tech without coding, tech scholarship for beginners Nigeria, non-technical tech jobs Africa, 
          career change to tech Nigeria, learn tech skills online Nigeria, funded tech training Nigeria, tech bootcamp scholarship 2026, data analytics scholarship Nigeria, product management scholarship Africa, 
          how to start a tech career Nigeria, Utiva scholarship programme, how to get into tech without a coding background, can I work in tech if I cant code, best tech scholarship for career changers in Nigeria, 
          how to use a scholarship to switch careers to tech, non-technical tech roles you can learn in 12 weeks"
        />
      </Helmet>

      <HomeHeaderSection />
      <HomeAnswerStripSection />
      <HomeLogoMarqueeSection />
      <HomeProgramsCarouselSection />
      <HomeFinderSection />
      <HomeLearningModelSection />
      <HomeWorkforceSection />
      <HomeJourneySection />
      <HomeEvidenceSection />
      <TestimonialsSection />
      <HomeTestimonialVideosSection />
      <HomeTrustStatsSection />
      <HomePlatformSection />
      {/* <HomeCompaniesSection /> */}
      <HomeBusinessSection />
      <HomeTalentNetworkSection />
      {/* <HomeRequestFormSection /> */}
      <HomeStorySection />
      <HomeFinalCtaSection />

      <FloatingHomeRequestButton />

      <SiteFooter />
    </div>
  );
};

export default Home;
